var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "o-width-limiter o-width-limiter--main t-margin--5-top t-margin--5-bottom",
        _vm.className
      ]
    },
    [
      _c(
        "div",
        {
          class: [
            {
              "c-info-video-block--video-left": _vm.videoAlignment === "left"
            },
            {
              "c-info-video-block--video-right": _vm.videoAlignment === "right"
            },
            "o-grid",
            "c-info-video-block"
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "o-grid__column",
              attrs: { "data-size": "sm:12 md:9" }
            },
            [
              _c(
                "div",
                {
                  class: [
                    "c-info-video-block__content",
                    _vm.color === "orange" && "c-info-video-block--orange",
                    _vm.color === "pink" && "c-info-video-block--pink",
                    _vm.color === "blue" && "c-info-video-block--blue",
                    _vm.color === "green" && "c-info-video-block--green"
                  ]
                },
                [
                  _c(
                    "div",
                    { staticClass: "c-info-video-block__content-wrapper" },
                    [
                      _c("div", { staticClass: "heading-header" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "c-info-video-block__heading heading-boarder"
                          },
                          [
                            _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.heading)),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.subHeading) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "c-info-video-block--icon",
                          attrs: {
                            src: "/gui/images/icons/" + _vm.icon + ".svg",
                            alt: _vm.icon
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.text
                        ? _c("p", { staticClass: "c-info-video-block__text" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.text) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          !_vm.isImage && !_vm.youTubeUrl
            ? _c("video-player", {
                staticClass: "c-info-video-block__video",
                attrs: { options: _vm.videoOptions }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-info-video-block__youtube" },
            [
              !_vm.isImage && _vm.youTubeUrl
                ? _c("you-tube-player", { attrs: { url: _vm.youTubeUrl } })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.isImage
            ? _c("img", {
                staticClass: "c-info-video-block__video",
                attrs: { src: _vm.imageSrc, alt: _vm.imageAlt }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }